module.exports = __webpack_public_path__ + "img/panic.8bfd9bef.gif";